const findObjectInNestedArray = (array, target) => {
  for (const currentObject of array) {
    if (currentObject.level === target.level) return currentObject;

    if (currentObject.body && currentObject.body?.length) {
      const nestedResult = findObjectInNestedArray(currentObject.body, target);
      if (nestedResult) return nestedResult;
    }
  }
  return null;
};

export default findObjectInNestedArray;
